import React, { Suspense, lazy } from "react";
import { Navigate, Outlet, Route, useLocation } from "react-router-dom";
import NaturalsAdminFlowLayout from "./NaturalsAdminFlowLayout";
import NaturalsAdminLayout from "./NaturalsAdminLayout";
import { RequirePortalAuth } from "../naturals-portal/pages/Login";
import { ENTERPRISE_CONTROL_BASE } from "../naturals-portal/naturals-control/constants";

const ProductAnalytics = lazy(() => import("../naturals-portal/pages/products/ProductAnalytics"));

const Fallback = () => (
  <div className="min-h-[40vh] flex items-center justify-center text-[#6b6280]">Loading…</div>
);

function NaturalsPortalProductRedirect() {
  return <Navigate to={ENTERPRISE_CONTROL_BASE} replace />;
}

function NaturalsOrgPortalRedirect() {
  const location = useLocation();
  const m = location.pathname.match(/^\/nyafaz-naturals\/organizations\/(\d+)(\/.*)?$/);
  const id = m?.[1];
  const rest = m?.[2] || "";
  if (!id) return <Navigate to={ENTERPRISE_CONTROL_BASE} replace />;
  if (rest.startsWith("/edit")) {
    return <Navigate to={`/naturals-portal/organizations/${id}/edit${location.search || ""}`} replace />;
  }
  return <Navigate to={`${ENTERPRISE_CONTROL_BASE}/organizations/${id}/manage${location.search || ""}`} replace />;
}

export function renderNaturalsAdminRoutes() {
  return (
    <>
      <Route path="/naturals-portal/products/naturals/*" element={<NaturalsPortalProductRedirect />} />
      <Route element={<NaturalsAdminFlowLayout />}>
        <Route
          element={
            <RequirePortalAuth>
              <Outlet />
            </RequirePortalAuth>
          }
        >
          <Route path="/nyafaz-naturals" element={<Navigate to={ENTERPRISE_CONTROL_BASE} replace />} />
          <Route
            path="/nyafaz-naturals/organizations"
            element={<Navigate to={`${ENTERPRISE_CONTROL_BASE}/organizations`} replace />}
          />
          <Route
            path="/nyafaz-naturals/organizations/:orgId/*"
            element={<NaturalsOrgPortalRedirect />}
          />
          <Route element={<NaturalsAdminLayout />}>
            <Route path="/nyafaz-naturals/overview" element={<Navigate to="/naturals-portal/home" replace />} />
            <Route
              path="/nyafaz-naturals/organizations/new"
              element={<Navigate to="/naturals-portal/organizations/new" replace />}
            />
            <Route
              path="/nyafaz-naturals/analytics"
              element={
                <Suspense fallback={<Fallback />}>
                  <ProductAnalytics />
                </Suspense>
              }
            />
            <Route path="/nyafaz-naturals/*" element={<Navigate to={ENTERPRISE_CONTROL_BASE} replace />} />
          </Route>
        </Route>
      </Route>
    </>
  );
}
